export const editorEnum = {
  headerType: 'Header',
  mainType: 'Main',
}
